export default "__VITE_ASSET__a0f14921__"